import PageFront from "../pages/PageFront/PageFront";
import PageCongratulations from "../pages/PageCongratulations/PageCongratulations";

import PageCousin from "../pages/PageCousin/PageCousin";
import PageCousinA from "../pages/PageCousinA/PageCousinA";
import PageCousinB from "../pages/PageCousinB/PageCousinB";
import PageCousinC from "../pages/PageCousinC/PageCousinC";
import PageCousinD from "../pages/PageCousinD/PageCousinD";
import PageCousinE from "../pages/PageCousinE/PageCousinE";
import PageCousinF from "../pages/PageCousinF/PageCousinF";
import PageCousinQuiz from "../pages/PageCousinQuiz/PageCousinQuiz";

import PageKid from "../pages/PageKid/PageKid";
import PageKidA from "../pages/PageKidA/PageKidA";
import PageKidB from "../pages/PageKidB/PageKidB";
import PageKidC from "../pages/PageKidC/PageKidC";
import PageKidD from "../pages/PageKidD/PageKidD";
import PageKidE from "../pages/PageKidE/PageKidE";
import PageKidF from "../pages/PageKidF/PageKidF";
import PageKidG from "../pages/PageKidG/PageKidG";
import PageKidQuiz from "../pages/PageKidQuiz/PageKidQuiz";

import PageMother from "../pages/PageMother/PageMother";
import PageMotherA from "../pages/PageMotherA/PageMotherA";
import PageMotherB from "../pages/PageMotherB/PageMotherB";
import PageMotherC from "../pages/PageMotherC/PageMotherC";
import PageMotherD from "../pages/PageMotherD/PageMotherD";
import PageMotherE from "../pages/PageMotherE/PageMotherE";
import PageMotherF from "../pages/PageMotherF/PageMotherF";
import PageMotherG from "../pages/PageMotherG/PageMotherG";
import PageMotherQuiz from "../pages/PageMotherQuiz/PageMotherQuiz";

import PageFather from "../pages/PageFather/PageFather";
import PageFatherA from "../pages/PageFatherA/PageFatherA";
import PageFatherB from "../pages/PageFatherB/PageFatherB";
import PageFatherC from "../pages/PageFatherC/PageFatherC";
import PageFatherD from "../pages/PageFatherD/PageFatherD";
import PageFatherE from "../pages/PageFatherE/PageFatherE";
import PageFatherQuiz from "../pages/PageFatherQuiz/PageFatherQuiz";

const ROUTES = [
  {
    path: "/",
    component: <PageFront />,
    exact: true,
  },
  {
    path: "/congratulations",
    component: <PageCongratulations />,
    exact: true,
  },

  {
    path: "/cousin/",
    component: <PageCousin />,
    exact: true,
  },
  {
    path: "/cousin/a",
    component: <PageCousinA />,
    exact: true,
  },
  {
    path: "/cousin/b",
    component: <PageCousinB />,
    exact: true,
  },
  {
    path: "/cousin/c",
    component: <PageCousinC />,
    exact: true,
  },
  {
    path: "/cousin/d",
    component: <PageCousinD />,
    exact: true,
  },
  {
    path: "/cousin/e",
    component: <PageCousinE />,
    exact: true,
  },
  {
    path: "/cousin/f",
    component: <PageCousinF />,
    exact: true,
  },
  {
    path: "/cousin/quiz",
    component: <PageCousinQuiz />,
    exact: true,
  },

  {
    path: "/kid/",
    component: <PageKid />,
    exact: true,
  },
  {
    path: "/kid/a",
    component: <PageKidA />,
    exact: true,
  },
  {
    path: "/kid/b",
    component: <PageKidB />,
    exact: true,
  },
  {
    path: "/kid/c",
    component: <PageKidC />,
    exact: true,
  },
  {
    path: "/kid/d",
    component: <PageKidD />,
    exact: true,
  },
  {
    path: "/kid/e",
    component: <PageKidE />,
    exact: true,
  },
  {
    path: "/kid/f",
    component: <PageKidF />,
    exact: true,
  },
  {
    path: "/kid/g",
    component: <PageKidG />,
    exact: true,
  },
  {
    path: "/kid/quiz",
    component: <PageKidQuiz />,
    exact: true,
  },

  {
    path: "/father/",
    component: <PageFather />,
    exact: true,
  },
  {
    path: "/father/a",
    component: <PageFatherA />,
    exact: true,
  },
  {
    path: "/father/b",
    component: <PageFatherB />,
    exact: true,
  },
  {
    path: "/father/c",
    component: <PageFatherC />,
    exact: true,
  },
  {
    path: "/father/d",
    component: <PageFatherD />,
    exact: true,
  },
  {
    path: "/father/e",
    component: <PageFatherE />,
    exact: true,
  },
  {
    path: "/father/quiz",
    component: <PageFatherQuiz />,
    exact: true,
  },

  {
    path: "/mother/",
    component: <PageMother />,
    exact: true,
  },
  {
    path: "/mother/a",
    component: <PageMotherA />,
    exact: true,
  },
  {
    path: "/mother/b",
    component: <PageMotherB />,
    exact: true,
  },
  {
    path: "/mother/c",
    component: <PageMotherC />,
    exact: true,
  },
  {
    path: "/mother/d",
    component: <PageMotherD />,
    exact: true,
  },
  {
    path: "/mother/e",
    component: <PageMotherE />,
    exact: true,
  },
  {
    path: "/mother/f",
    component: <PageMotherF />,
    exact: true,
  },
  {
    path: "/mother/g",
    component: <PageMotherG />,
    exact: true,
  },
  {
    path: "/mother/quiz",
    component: <PageMotherQuiz />,
    exact: true,
  },
];

export default ROUTES;
